module.exports = __webpack_public_path__ + "img/payments-icon.cc521388.svg";